module.exports = __webpack_public_path__ + "static/media/strokecolor.8bc47db3.svg";